import Image from "next/image";
import Spinner from "@/components/ui/spinner";

interface AuthCardProps {
  children: React.ReactNode;
  isLoading: boolean;
  heading: string;
  className?: string;
  subHeading?: string | React.ReactNode;
}
const AuthCard: React.FC<AuthCardProps> = ({
  children,
  isLoading,
  heading,
  className,
  subHeading,
}) => {
  return (
    <div className="relative z-10 w-full px-4">
      <Spinner show={isLoading} />
      <div
        className={`mx-auto w-full max-w-sm rounded-2xl bg-white ${className}`}
      >
        <div className="px-6 py-8 sm:px-8">
          {/* Brand */}
          <div className="flex items-center justify-center gap-1">
            <Image
              src="/images/app/main-logo.png"
              alt="ReEquip Logo"
              width={200}
              height={80}
              priority
            />
          </div>

          <div className="space-y-6 mt-4">
            {/* Welcome */}
            <div className="space-y-2 text-center">
              <h2 className=" text-xl font-medium text-slate-900">{heading}</h2>
              {subHeading && (
                <p className="text-slate-600 text-sm">{subHeading}</p>
              )}
            </div>

            {children}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AuthCard;
